<div mat-dialog-title>
    <ng-container *ngIf="!oldSamples">Se generó correctamente la solicitud</ng-container> 
    <ng-container *ngIf="oldSamples">Se modificó correctamente la solicutd</ng-container>
    <div class="spacer"></div>
    <button mat-raised-button class="float-right mb-1" color="primary"><mat-icon>print</mat-icon></button>

  </div>
  <mat-dialog-content>
           <table class="table">
              <thead>
              <tr>
                <th scope="col">Etiqueta</th>
                <th scope="col">Contenedor</th>
                <th scope="col">Material</th>
                <th scope="col">Test</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let sample of samples" [class.old-sample-row]="!isNew(sample)">
                <td class="align-middle">{{ sample?.labelId }}</td>
                <td class="align-middle">{{ sample?.containerId }}</td>
                <td class="align-middle">{{ sample?.specimenId }}</td>
                <td class="align-middle">
                  <mat-chip-list>
                    <mat-chip color="primary" *ngFor="let test of sample.tests"
                        [matTooltip]="test.description">{{test.id}}</mat-chip>
                  </mat-chip-list>
                </td>
                <td class="align-middle"> <button mat-raised-button [class.new-sample]="isNew(sample)"><mat-icon (click)="printLabel(sample)">print</mat-icon></button></td>

              </tr>
              </tbody>
            </table>
  
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Finalizar</button>
  </mat-dialog-actions>
  <!--
0:
containerId: "GELCL17"
profileId: "GLU30"
profileProgressive: 1
sampleProgressive: 1
seqOrder: 7353522
specimenId: "SUE"
testId: ".CURV"
testProgressive: 1
zoneDescription: "0-División Analítica"
zoneId: 0
__proto__: Object
1:
containerId: "GELCL17"
profileId: "GLU30"
profileProgressive: 2
sampleProgressive: 1
seqOrder: 7353522
specimenId: "SUE"
testId: "GLU"
testProgressive: 1
zoneDescription: "0-División Analítica"
zoneId: 0
__proto__: Object
2:
containerId: "SUE 30m"
profileId: "GLU30"
profileProgressive: 3
sampleProgressive: 2
seqOrder: 7353522
specimenId: "SUE"
testId: "GLU30"
testProgressive: 1
zoneDescription: "0-División Analítica"
zoneId: 0

-->